<template>
	<div class="w-full">
		<div class="mb-3">
			<span class="mb-0 font-medium text-gray-650">Location</span>
		</div>

		<div v-if="isDirty" class="m-0 space-y-3 p-0">
			<FilterSelectbox
				ref="stateOptionsSelect"
				v-model="states"
				mode="multiple"
				:options="stateOptions"
				value-prop="value"
				label="label"
				placeholder="Location"
				:searchable="true"
				:groups="false"
				:can-deselect="true"
				:close-on-select="false"
				:hide-selected="false"
				:show-apply-and-clear="true"
				:can-clear="false"
				@apply="onApply($event, 'states')"
				@close="onApply($event, 'states')"
				@clear="onClear('states')"
			/>
		</div>

		<div v-if="showContentLoader" class="flex flex-col gap-2">
			<ContentLoader width="w-full" height="h-[50px]" />
		</div>
	</div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import FilterSelectbox from '@/components/selectboxes/FilterSelectbox.vue'
import { useProductCatalog } from '@/stores/product-catalog'
import ContentLoader from '@/components/ContentLoader.vue'

const productCatalog = useProductCatalog()

const states = ref(
	productCatalog.filters.states.length
		? productCatalog.filters.states
		: ['all']
)

const stateOptionsSelect = ref(null)

const stateOptions = computed(() =>
	productCatalog.facets.states.filter((option) => !option.hidden)
)

const isDirty = computed(() => productCatalog.isDirty)

const showContentLoader = computed(() => !isDirty.value)

watch(states, (newValue, oldValue) => {
	states.value = handleAllSelection(newValue, oldValue, states)
})

watch(
	() => productCatalog.filters.states,
	(newValue) => {
		states.value = newValue.length === 0 ? ['all'] : newValue
	}
)

const handleAllSelection = (newValue, oldValue, facet) => {
	let { value } = facet

	// when adding the 'all' option, remove all other selections
	if (
		newValue.length > 1 &&
		!oldValue.some((item) => `${item}`.toLowerCase() === 'all') &&
		newValue.some((item) => `${item}`.toLowerCase() === 'all')
	) {
		value = ['all']
	}

	// when adding an option while the 'all' option is selected,
	// remove the 'all' option
	if (
		newValue.length > 1 &&
		oldValue.some((item) => `${item}`.toLowerCase() === 'all') &&
		newValue.some((item) => `${item}`.toLowerCase() === 'all')
	) {
		const index = value.indexOf('all')
		if (index > -1) {
			value.splice(index, 1)
		}
	}

	return value
}

const onApply = (filterValue, filterKey) => {
	let updateFilterValue = filterValue

	if (filterValue.some((item) => `${item}`.toLowerCase() === 'all')) {
		updateFilterValue = ['all']
	}

	updateFilter(updateFilterValue, filterKey)
}

const onClear = (filterKey) => {
	updateFilter(['all'], filterKey)
}

const updateFilter = (filterValue, filterKey) => {
	let updateFilterValue = filterValue

	// handle when 'all' is selected
	if (updateFilterValue.some((item) => `${item}`.toLowerCase() === 'all')) {
		updateFilterValue = []
	}

	productCatalog.updateFilter({
		filterKey,
		filterValue: updateFilterValue,
	})
}
</script>
